//фото стоянок модальное окно (добавление)
import React from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CButton,
} from '@coreui/react';

const PhotoParkingModal = ({ visible, onClose, onSave, name, setName, filePath, setFilePath }) => {
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFilePath(event.target.files[0].name);
    }
  };

  return (
    <CModal visible={visible} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>Фото стоянок</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="mb-3">
            <CCol md="4">
              <CFormLabel>Наименование</CFormLabel>
            </CCol>
            <CCol>
              <CFormInput value={name} onChange={(e) => setName(e.target.value)} />
            </CCol>
          </CRow>

          <CRow className="mb-3 align-items-end">
            <CCol md="4">
              <CFormLabel>Путь к файлу</CFormLabel>
            </CCol>
            <CCol>
              <CFormInput value={filePath} readOnly />
            </CCol>
            <CCol sm="auto">
              <label className="btn btn-outline-secondary mb-0">
                Обзор
                <input type="file" hidden onChange={handleFileChange} />
              </label>
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => onSave({ filePath, name })}>
          Сохранить
        </CButton>
        <CButton color="secondary" onClick={onClose}>
          Отменить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default PhotoParkingModal;